import React from 'react';
import { concat, of, EMPTY, forkJoin } from 'rxjs';
import { mergeMap, switchMap, debounceTime, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { ErrorModal } from '../../../components/modals/error-modal';
import Global from '../../../store/global-selectors';
import { ModalService } from 'ui-components/services/modal-service';
import { ALERT_DISMISSAL_SUCCESS } from '../../../store/alerts/grid/alerts.grid.actions';
import * as NavActions from '../../../store/orders/nav/orders.nav.actions';
import * as OrdersActions from '../../../store/orders/orders.actions';
import * as OrdersApi from '../../../store/orders/orders.api';
import * as OrderAlertsApi from '../../../store/order-alerts/order-alerts.api';

import { hasQuickSearchTerm } from './../../../services/quicksearch-service';
import { messages } from '../messages';
import { pushToHistoryWithSearchTerm } from '../../../services/quicksearch-location-service';
import { ORDERS_CHANGE_VIEW_SEARCH } from '../../../store/orders/nav/orders.nav.actions';

export const quickSearchFromScanToSearchEpic = (action$) =>
  action$.pipe(
    ofType(NavActions.QUICKSEARCH_FROM_SCAN_TO_SEARCH),
    mergeMap(({ searchTerm, history }) => {
      pushToHistoryWithSearchTerm(history, searchTerm);
      return concat([NavActions.changeViewSearch({ searchTerm }), NavActions.ordersSearchTermCount()]);
    }),
  );

export const ordersGetCountsEpic = (action$, { getState }) =>
  action$.pipe(
    ofType(
      OrdersActions.GET_ORDERS_REQUEST,
      OrdersActions.GET_SILENT_ORDERS_REQUEST,
      OrdersActions.GET_ORDERS_COUNTS,
      ORDERS_CHANGE_VIEW_SEARCH,
      ALERT_DISMISSAL_SUCCESS,
    ),
    debounceTime(500),
    switchMap(() => {
      const searchData = Global.selectOrdersNavSearchData(getState());
      const quickSearchPerformed = hasQuickSearchTerm(searchData);
      if (quickSearchPerformed) {
        return of(NavActions.ordersSearchTermCount());
      }

      return forkJoin(OrdersApi.getOrdersCounts(), OrderAlertsApi.getOrderAlertsCounts()).pipe(
        mergeMap((calls) => {
          const counts = [...get(calls, '0.statusListByStore', []), ...get(calls, '1', [])];
          return of(NavActions.ordersGetCountsSuccess(counts));
        }),
        catchError(() => {
          // NOTE: IF both api calls fail, this will launch a modal for each API call. Not sure how to best handle this.
          ModalService.launchModal({
            component: ErrorModal,
            props: {
              title: <FormattedMessage {...messages.orderCountsErrorTitle} />,
              message: <FormattedMessage {...messages.orderCountsErrorMessage} />,
              state: 'warning',
            },
          });
          return EMPTY;
        }),
      );
    }),
  );
